<freud-select
	optionLabel="value"
	optionValue="id"
	[options]="options"
	[label]="'SCHEDULE.RECURRENCY' | translate"
	(onChange)="selectOption($event.value)"
	[ngModel]="_value"
	[disabled]="action === 'edit'"
></freud-select>
